import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import Dashboard from './components/Dashboard';
import CriticalNotification from './components/notification/CriticalNotification';
import PushNotification from './components/notification/PushNotification';
import LoginForm from './components/LoginForm';
import Instructions from './components/Instruction/Instructions';
import Points from './components/point/PointsList';
import Sidebar from "./components/Sidebar";
import News from "./components/news/NewsList.js";

function App() {
    const isAuthenticated = !!localStorage.getItem('token');

    return (<Router>
        <div className="App">
            {isAuthenticated ? (<>
                <Sidebar/>
                <div className="content">
                    <Routes>
                        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard"/> : <LoginForm/>}/>
                        <Route path="/dashboard" element={isAuthenticated ? <Dashboard/> : <Navigate to="/login"/>}/>
                        <Route path="/critical-notification"
                               element={isAuthenticated ? <CriticalNotification/> : <Navigate to="/login"/>}/>
                        <Route path="/push-notification"
                               element={isAuthenticated ? <PushNotification/> : <Navigate to="/login"/>}/>
                        <Route path="/instructions"
                               element={isAuthenticated ? <Instructions/> : <Navigate to="/instructions"/>}/>
                        <Route path="/points"
                               element={isAuthenticated ? <Points/> : <Navigate to="/points"/>}/>
                        <Route path="*" element={<Navigate to="/dashboard"/>}/>
                        <Route path="/news"
                               element={isAuthenticated ? <News/> : <Navigate to="/news"/>}/>
                        <Route path="*" element={<Navigate to="/dashboard"/>}/>
                    </Routes>
                </div>
            </>) : <LoginForm/>}

        </div>
    </Router>);
}

export default App;
    